import { SPACING } from '@alto/design-library-tokens';
import { Body } from '@alto/design-system';
import styled from 'styled-components';
import { EmptyStateBox } from '~web/features/app/components/EmptyStateBox';

export const StyledParagraph = styled(Body)`
  margin-bottom: ${SPACING.STATIC.MD.rem};
`;

export default EmptyStateBox;
